import type { PollResponse } from "@circle-react-shared/uikit/TipTapBlockEditor/PollExtension/PollModal/api";
import type { Editor, Range } from "@tiptap/react";

export const insertPollNode = ({
  editor,
  range,
  poll,
  addToLocalSgidToObjectMap,
}: {
  addToLocalSgidToObjectMap: (params: {
    sgid: string;
    object: PollResponse;
  }) => void;
  editor: Editor;
  poll: PollResponse;
  range: Range;
}) => {
  editor
    .chain()
    .focus()
    .insertContentAt(range, [
      {
        type: "poll",
        attrs: {
          sgid: poll.sgid,
        },
      },
      {
        type: "hardBreak",
      },
    ])
    .run();
  addToLocalSgidToObjectMap({ sgid: poll.sgid, object: poll });
};
